import { useSmartMutation, useSmartQuery } from"@shared/api/queries/hooks";
import { QueryKeyFactory } from"@shared/api/queries/queryKeyFactory";
import { requestsApi } from"./api";
import { ConsumerRequestFilters } from"./types";
import { useNavigate } from "react-router-dom";
import { queryClient } from "@shared/api/queries/queryClient";


export const useConsumerRequests = (filters: ConsumerRequestFilters) => {
 return useSmartQuery(
  ["cx", "consumerRequests", "list", filters],
  () => requestsApi.getConsumerRequests(filters),
  {
   enabled: !!filters.consumer_id && !!filters.remote_utility_id && (Array.isArray(filters.consumer_id) ? filters.consumer_id.length > 0 : true),
  }
 );
};

export const useRequestStatuses = () => {
  return useSmartQuery(
    ["cx", "requestStatuses"],
    () => requestsApi.getRequestStatuses(),
    {}
  );
};

export const useCreateTransferRequest = () => {
  const navigate = useNavigate();
  return useSmartMutation(
    (payload: {data: FormData}) => requestsApi.createTransferRequest(payload.data),
    {
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["cx", "consumerRequests", "list"] });
        }
    }
  );
};